import type { Theme } from 'app/providers/theme';

/** Typography colors for the leads guide modal (dark surface). */
export const getGuideColors = (semantic: Theme['semantic']) => ({
  textPrimary: semantic.text_small_elements,
  textSecondary: semantic.neutrals_700,
  textMuted: semantic.neutrals_600,
  textSubtle: semantic.neutrals_500,
  textAccent: semantic.accent_500,
  textComplianceBody: semantic.neutrals_800,
});
